<template>
	<div class="full">
		<vxe-grid ref="initoutputinvoiceorderTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<invoiceConfig ref="invoiceConfig" :invoicedata="invoicedata" :tab="tab" @modalhide="invoiceConfigHide" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import invoiceConfig from '../../invoice/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return {}
				}
			},
			store: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				step: 1,
				invoicedata:[],
				tab:[],
				goodsUids:[],
				currentrow:null,
				modal_model: true,
				modal_title: '生成亿企赢单据',
				modal_width: 1200,
				modal_height: 800,
				list_footerField:[
					{field:'price',toFixed:6},
					{field:'taxprice',toFixed:6},
					{field:'totalPrice',toFixed:6},
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			sourcefile(row) {
				this.invoicedata = {
					invoiceNumber:row.invoiceNumber,
					customerId:row.customerId,
					invoiceId:row.invoiceId,
					orderId:row.orderId,
					orderPlant:row.orderPlant,
					invoiceType:0
				}
				this.tab = ['invoice']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			invoiceConfigHide(){
				
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [
					{field:'invoiceNumber',title:'发票号码',render:'$input',props:{show:true},fixed:'left',width:150},
					{
						field:'buyerName',
						title:'购买方',
						props:{show:true},
						width:100,
					},
					{
						field:'suplierName',
						title:'销售方',
						props:{show:true},
						width:100,
					},
					{
						field:'invoiceClass',
						title:'发票种类',
						render:'$input',
						formatter:({cellValue})=>{
							if(cellValue == 31){
								return '数电票（专票）'
							}
							if(cellValue == 32){
								return '数电票（普票）'
							}									
						},
						props:{show:true},
						width:100,
					},
					{
						field:'bizDate',
						title:'开票日期',
						render:'$datePicker',
						formatter:({cellValue})=>{
							return window.systemMethods.timestampToDate(cellValue)
						},
						props:{show:true},
						width:100,
					},
					{
						field:'invoiceStatus',
						title:'发票状态',
						render:'',
						formatter:({cellValue})=>{
							if(cellValue == 0){
								return '正常'
							}
							if(cellValue == 3){
								return '红冲'
							}
									
						},
						props:{show:true},
						width:100,
					},
					{field:'cargoName',title:'货物、应税劳务及服务',sortable:true,render:'',props:{show:true},width:100},
					{field:'taxItem',title:'征税项目',render:'',props:{show:true},width:100},
					{field:'suplierName',title:'销方名称',render:'',props:{show:true},width:100,sortable:true},
					{field:'cargoPrice',title:'不含税金额',render:'',props:{show:true},width:100},		
					{field:'taxRates',title:'税率',render:'',props:{show:true},width:100},	
					{field:'taxPrice',title:'税额',render:'',props:{show:true},width:100},	
					{field:'totalPrice',title:'价税合计',render:'',props:{show:true},width:100,fixed: "right",},	
					{field:'drawerName',title:'开票人',render:'',props:{show:true},width:100},																	
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 100,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.sourcefile(row)}}>原件</el-button>,									
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.invoice.initinputinvoiceorder({
						invoiceNumber: this.data.invoiceNumber,
						relationinvoice: 1
					}).then((res) => {
						this.store.invoicelist = res.list
						resolve(res)
					},()=>{
						this.loading = false
					})
				})
			},
			valid(){
				let data = this.$refs.initoutputinvoiceorderTable.getTableData().fullData
				let cargoNameBuff = false
				for(let i =0 ;i<data.length;i++){
					if(!data[i].cargoName){
						cargoNameBuff = data[i]
						break;
					}
				}
				if(cargoNameBuff){
					this.$refs.initoutputinvoiceorderTable.scrollToRow(cargoNameBuff)
				}
				return cargoNameBuff
			},
			submit() {

				//this.init()
			},
			reset() {
				//this.init()
			},
			customreload() {
				this.$refs.initoutputinvoiceorderTable.commitProxy('query')
			},
		},
		components: {
			invoiceConfig
		}
	}
</script>